"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bomarzo": {
    "bb974999": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "skipSearch": false
    }],
    "rione-borgo": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f42df4aa": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "skipSearch": false
    }],
    "rione-croci": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d4e6874a": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "skipSearch": false
    }],
    "rione-madonna-del-piano": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2b7f7ed": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "skipSearch": false
    }],
    "rione-poggio": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d2d3538f": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-rione-dentro": [{
      "hkey": "95027323",
      "slug": "bomarzo",
      "name": "Bomarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;